export const CIPO_V1ResourcesDE: CIPO_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  type: {
    EvdLabel: "Notiz",
    Name: "type",
    Placeholder:
      "Eingeben: Regelmäßig, außerordentlich, allgemein, wöchentlich, monatlich, jährlich...",
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
  errors: {
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
};

interface Type {
  EvdLabel: string;
  Name: string;
  Placeholder: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface CIPO_V1ResourcesBSInterface {
  labelDone: string;
  type: Type;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: {
    recordAlreadyExists: string;
  };
}
